import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lp-wave-content" }
const _hoisted_2 = { class: "lp-wave-login ly-row ly-center-center" }
const _hoisted_3 = { class: "ly-col ly-center-center forgot-password-container" }
const _hoisted_4 = { class: "card lp-load-fadein" }

import MfaSmsConfirmForm from './components/MfaSmsConfirmForm.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'MfaSmsConfirmView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _directive_load_fade_in = _resolveDirective("load-fade-in")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createVNode(MfaSmsConfirmForm)
            ], 512), [
              [_vShow, true]
            ])
          ]),
          _: 1
        })
      ])), [
        [_directive_load_fade_in, { delay: 1000, timeBetween: 500 }]
      ])
    ])
  ]))
}
}

})